// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27 fill=%27%23666%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z%27 clip-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MyClients.scss */
:root {
  --text-color: #374151;
  --light-gray: #f3f4f6;
  --medium-gray: #e5e7eb;
  --border-color: #d1d5db;
  --card-bg: #ffffff;
  --shadow-light: rgba(0, 0, 0, 0.05);
  --shadow-medium: rgba(0, 0, 0, 0.08);
}

.my-clients-wrapper .filter-group label {
  display: block;
  margin-bottom: 8px;
}
.my-clients-wrapper .view-toggle-wrapper {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.my-clients-wrapper .view-toggle-wrapper .view-toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  font-weight: 500;
  background-color: transparent;
  color: #444;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.my-clients-wrapper .view-toggle-wrapper .view-toggle-btn svg {
  font-size: 1rem;
  color: inherit;
}
.my-clients-wrapper .view-toggle-wrapper .view-toggle-btn:hover {
  background-color: #f3f4f6;
}
.my-clients-wrapper .view-toggle-wrapper .view-toggle-btn.active {
  background-color: #e5e7eb;
  color: #222;
  border-color: #cbd5e1;
}
.my-clients-wrapper .clients-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  gap: 1rem;
  padding: 15px;
  background-color: #f8f9fa;
  box-sizing: border-box;
  margin-top: 1rem;
}
.my-clients-wrapper .clients-container .clients-table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--card-bg);
  border-radius: 0.5rem;
  overflow: hidden;
  font-size: 0.95rem;
  box-shadow: 0 2px 6px var(--shadow-light);
}
.my-clients-wrapper .clients-container .clients-table thead {
  background-color: #f1f5f9;
}
.my-clients-wrapper .clients-container .clients-table thead th {
  text-align: left;
  padding: 1rem;
  color: #111827;
}
.my-clients-wrapper .clients-container .clients-table tbody tr {
  transition: background-color 0.2s ease;
}
.my-clients-wrapper .clients-container .clients-table tbody tr:hover {
  background-color: #f9fafb;
}
.my-clients-wrapper .clients-container .clients-table tbody tr td {
  padding: 0.9rem 1rem;
}
.my-clients-wrapper .clients-container .clients-table tbody tr td:last-child {
  white-space: nowrap;
}
.my-clients-wrapper .clients-container .clients-table tbody tr td:last-child button {
  margin-right: 0.5rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #17a2b8;
  color: white;
}
.my-clients-wrapper .clients-container .clients-table tbody tr td:last-child button:last-child {
  background-color: #dc2626;
}
.my-clients-wrapper .clients-container .clients-table tbody tr td:last-child button:hover {
  opacity: 0.9;
}
.my-clients-wrapper .clients-container .client-card-main {
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.75rem;
  padding: 1rem;
  position: relative;
}
.my-clients-wrapper .clients-container .client-card-main .client-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px dashed var(--medium-gray);
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-name {
  font-size: 1.2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions {
  position: relative;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .client-action-button {
  background-color: var(--primary-color);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  padding: 8px 18px;
  font-size: 0.95rem;
  color: var(--text-color);
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .client-action-button:hover {
  box-shadow: 0 1px 4px var(--shadow-medium);
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .client-action-button svg {
  font-size: 1.1rem;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .dropdown-menu {
  position: absolute;
  top: 3rem;
  right: 0;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  box-shadow: 0 6px 16px var(--shadow-medium);
  min-width: 180px;
  padding: 0.5rem 0;
  z-index: 100;
  list-style: none;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .dropdown-menu li {
  padding: 0.75rem 1.2rem;
  font-size: 0.9rem;
  color: var(--text-color);
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .dropdown-menu li:hover {
  background-color: var(--light-gray);
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .dropdown-menu li:not(:last-child) {
  border-bottom: 1px solid var(--medium-gray);
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .dropdown-menu li.view {
  color: #2563eb;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .dropdown-menu li.update {
  color: #10b981;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .dropdown-menu li.delete {
  color: #ef4444;
}
.my-clients-wrapper .clients-container .client-card-main .client-header .client-actions .dropdown-menu li.message {
  color: #8b5cf6;
}
.my-clients-wrapper .clients-container .client-card-main .client-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px dashed var(--medium-gray);
}
.my-clients-wrapper .clients-container .client-card-main .client-details-grid .detail-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.95rem;
  color: var(--text-color);
}
.my-clients-wrapper .clients-container .client-card-main .client-details-grid .detail-item strong {
  color: #1f2937;
}
.my-clients-wrapper .clients-container .client-card-main .client-details-grid .detail-item .client-detail {
  color: #6b7280;
}
.my-clients-wrapper .clients-container .client-card-main .client-details-grid .detail-item .detail-icon {
  color: var(--primary-color);
  font-size: 1.2rem;
}
.my-clients-wrapper .clients-container .client-card-main .section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.8rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.my-clients-wrapper .clients-container .client-card-main .section-title .section-icon {
  color: var(--primary-color);
  font-size: 1.3rem;
}
.my-clients-wrapper .clients-container .client-card-main .client-address p {
  line-height: 1.6;
  margin: 0;
  color: var(--text-color);
  font-size: 0.95rem;
}
.my-clients-wrapper .clients-container .client-card-main .client-address p .client-detail {
  color: #6b7280;
}
.my-clients-wrapper .clients-container .client-card-main .client-cases .case-counts {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1rem;
  font-size: 0.95rem;
  color: var(--text-color);
}
.my-clients-wrapper .clients-container .client-card-main .client-cases .case-counts span .client-detail {
  color: var(--primary-color);
  font-weight: 600;
}
.my-clients-wrapper .clients-container .client-card-main .client-cases .case-list {
  margin-top: 0.5rem;
}
.my-clients-wrapper .clients-container .client-card-main .client-cases .case-list strong {
  display: block;
  margin-bottom: 0.3rem;
  color: #1f2937;
}
.my-clients-wrapper .clients-container .client-card-main .client-cases .case-list ul {
  list-style-type: disc;
  padding-left: 1.2rem;
  margin: 0;
}
.my-clients-wrapper .clients-container .client-card-main .client-cases .case-list ul li {
  color: var(--text-color);
  font-size: 0.9rem;
  line-height: 1.4;
}
.my-clients-wrapper .clients-container .no-clients-message {
  text-align: center;
  font-size: 1.1rem;
  color: var(--text-color-medium);
  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);
  background: var(--card-bg);
  border-radius: 0.75rem;
  border: 1px dashed var(--border-color);
  box-shadow: 0 2px 5px var(--shadow-light);
  margin-top: calc(var(--spacing-unit) * 2);
  grid-column: 1/-1;
}
.my-clients-wrapper .pagination-settings {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  padding: 4px 10px;
  background-color: #e2e8f0;
  border-radius: 6px;
}
.my-clients-wrapper .pagination-settings label {
  white-space: nowrap;
  color: #1f2937;
  font-size: 0.85rem;
  font-weight: 400;
}
.my-clients-wrapper .pagination-settings #clientPerPageSelect {
  border: none;
  border-radius: 6px;
  outline: none;
  padding: 3px 25px 3px 3px;
  background-color: white;
  font-size: 0.85rem;
  color: #333;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  transition: all 0.2s ease;
  box-shadow: none !important;
}
.my-clients-wrapper .pagination-settings #clientPerPageSelect:hover {
  background-color: #fafafa;
}
.my-clients-wrapper .pagination-settings #clientPerPageSelect:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  background-color: white;
}
.my-clients-wrapper .pagination-settings #clientPerPageSelect option {
  border: none !important;
  outline: none;
  padding: 4px 8px;
}

/* Media Queries for Responsiveness */
@media (max-width: 768px) {
  .clients-container {
    padding: 1rem;
  }
  .clients-container .client-card-main {
    padding: 1.5rem;
  }
  .clients-container .client-card-main .client-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.8rem;
  }
  .clients-container .client-card-main .client-header .client-name {
    font-size: 1.5rem;
  }
  .clients-container .client-card-main .client-header .client-actions {
    align-self: flex-end;
    width: 100%;
  }
  .clients-container .client-card-main .client-header .client-actions .client-action-button {
    width: 100%;
    justify-content: center;
  }
  .clients-container .client-card-main .client-header .client-actions .dropdown-menu {
    width: 100%;
    left: 0;
    right: auto;
    transform: translateX(0);
    text-align: center;
  }
  .clients-container .client-card-main .client-details-grid {
    grid-template-columns: 1fr;
  }
  .clients-container .client-card-main .client-address p,
  .clients-container .client-card-main .client-address ul,
  .clients-container .client-card-main .client-cases p,
  .clients-container .client-card-main .client-cases ul {
    font-size: 0.9rem;
  }
}
@media (max-width: 480px) {
  .clients-container {
    padding: 0.5rem;
  }
  .clients-container .client-card-main {
    padding: 1rem;
  }
  .clients-container .client-card-main .client-name {
    font-size: 1.3rem;
  }
  .clients-container .client-card-main .section-title {
    font-size: 1rem;
  }
  .clients-container .client-card-main .detail-item,
  .clients-container .client-card-main .client-address p,
  .clients-container .client-card-main .client-cases .case-counts span,
  .clients-container .client-card-main .client-cases .case-list ul li {
    font-size: 0.85rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/MyClients/MyClients.scss"],"names":[],"mappings":"AAAA,mBAAA;AAEA;EACE,qBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mCAAA;EACA,oCAAA;AAAF;;AAIE;EACE,cAAA;EACA,kBAAA;AADJ;AAIE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAFN;AAIM;EACE,eAAA;EACA,cAAA;AAFR;AAKM;EACE,yBAAA;AAHR;AAMM;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AAJR;AASE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AAPJ;AASI;EACE,WAAA;EACA,yBAAA;EACA,gCAAA;EAEA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AARN;AAUM;EACE,yBAAA;AARR;AAUQ;EACE,gBAAA;EACA,aAAA;EACA,cAAA;AARV;AAeQ;EACE,sCAAA;AAbV;AAeU;EACE,yBAAA;AAbZ;AAgBU;EACE,oBAAA;AAdZ;AAmBU;EACE,mBAAA;AAjBZ;AAmBY;EACE,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AAjBd;AAmBc;EACE,yBAAA;AAjBhB;AAoBc;EACE,YAAA;AAlBhB;AA0BI;EACE,gCAAA;EACA,qCAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;AAxBN;AA0BM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,4CAAA;AAxBR;AA0BQ;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAxBV;AA2BQ;EACE,kBAAA;AAzBV;AA2BU;EACE,sCAAA;EACA,qCAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,4DAAA;AAzBZ;AA2BY;EAEE,0CAAA;AA1Bd;AA6BY;EACE,iBAAA;AA3Bd;AA+BU;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,qCAAA;EACA,qBAAA;EACA,2CAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AA7BZ;AA+BY;EACE,uBAAA;EACA,iBAAA;EACA,wBAAA;EACA,eAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;AA7Bd;AA+Bc;EACE,mCAAA;AA7BhB;AAgCc;EACE,2CAAA;AA9BhB;AAiCc;EACE,cAAA;AA/BhB;AAmCc;EACE,cAAA;AAjChB;AAqCc;EACE,cAAA;AAnChB;AAuCc;EACE,cAAA;AArChB;AA8CM;EACE,aAAA;EACA,2DAAA;EAIA,SAAA;EACA,qBAAA;EACA,oBAAA;EACA,4CAAA;AA/CR;AAiDQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;AA/CV;AAiDU;EACE,cAAA;AA/CZ;AAkDU;EACE,cAAA;AAhDZ;AAmDU;EACE,2BAAA;EACA,iBAAA;AAjDZ;AAsDM;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AApDR;AAsDQ;EACE,2BAAA;EACA,iBAAA;AApDV;AAyDQ;EACE,gBAAA;EACA,SAAA;EACA,wBAAA;EACA,kBAAA;AAvDV;AAyDU;EACE,cAAA;AAvDZ;AA6DQ;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;AA3DV;AA8DY;EACE,2BAAA;EACA,gBAAA;AA5Dd;AAiEQ;EACE,kBAAA;AA/DV;AAiEU;EACE,cAAA;EACA,qBAAA;EACA,cAAA;AA/DZ;AAkEU;EACE,qBAAA;EACA,oBAAA;EACA,SAAA;AAhEZ;AAkEY;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;AAhEd;AAuEI;EAUE,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,oEAAA;EACA,0BAAA;EACA,sBAAA;EACA,sCAAA;EACA,yCAAA;EACA,yCAAA;EACA,iBAAA;AA9EN;AAkFE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AAhFJ;AAkFI;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAhFN;AAmFI;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EAKA,gBAAA;EAEA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EAEA,yBAAA;EACA,2BAAA;AArFN;AAuFM;EACE,yBAAA;AArFR;AAwFM;EACE,wDAAA;EACA,uBAAA;AAtFR;AAyFM;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;AAvFR;;AA6FA,qCAAA;AACA;EACE;IACE,aAAA;EA1FF;EA4FE;IACE,eAAA;EA1FJ;EA4FI;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;EA1FN;EA4FM;IACE,iBAAA;EA1FR;EA6FM;IACE,oBAAA;IACA,WAAA;EA3FR;EA6FQ;IACE,WAAA;IACA,uBAAA;EA3FV;EA8FQ;IACE,WAAA;IACA,OAAA;IACA,WAAA;IACA,wBAAA;IACA,kBAAA;EA5FV;EAiGI;IACE,0BAAA;EA/FN;EAoGM;;;;IAEE,iBAAA;EAhGR;AACF;AAsGA;EACE;IACE,eAAA;EApGF;EAsGE;IACE,aAAA;EApGJ;EAsGI;IACE,iBAAA;EApGN;EAuGI;IACE,eAAA;EArGN;EAwGI;;;;IAIE,kBAAA;EAtGN;AACF","sourcesContent":["/* MyClients.scss */\n\n:root {\n  --text-color: #374151;\n  --light-gray: #f3f4f6;\n  --medium-gray: #e5e7eb;\n  --border-color: #d1d5db;\n  --card-bg: #ffffff;\n  --shadow-light: rgba(0, 0, 0, 0.05);\n  --shadow-medium: rgba(0, 0, 0, 0.08);\n}\n\n.my-clients-wrapper {\n  .filter-group label {\n    display: block;\n    margin-bottom: 8px; // Adjust as needed\n  }\n\n  .view-toggle-wrapper {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n\n    .view-toggle-btn {\n      display: flex;\n      align-items: center;\n      gap: 0.3rem;\n      padding: 0.3rem 0.6rem;\n      font-size: 0.85rem;\n      font-weight: 500;\n      background-color: transparent;\n      color: #444;\n      border: 1px solid var(--border-color);\n      border-radius: 6px;\n      cursor: pointer;\n      transition: all 0.2s ease;\n\n      svg {\n        font-size: 1rem;\n        color: inherit;\n      }\n\n      &:hover {\n        background-color: #f3f4f6;\n      }\n\n      &.active {\n        background-color: #e5e7eb;\n        color: #222;\n        border-color: #cbd5e1;\n      }\n    }\n  }\n\n  .clients-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));\n    gap: 1rem;\n    padding: 15px;\n    background-color: #f8f9fa;\n    box-sizing: border-box;\n    margin-top: 1rem;\n\n    .clients-table {\n      width: 100%;\n      border-collapse: collapse;\n      background-color: var(--card-bg);\n      // border: 1px solid var(--border-color);\n      border-radius: 0.5rem;\n      overflow: hidden;\n      font-size: 0.95rem;\n      box-shadow: 0 2px 6px var(--shadow-light);\n\n      thead {\n        background-color: #f1f5f9;\n\n        th {\n          text-align: left;\n          padding: 1rem;\n          color: #111827;\n          // border-bottom: 1px solid var(--medium-gray);\n          // border: 1px solid #ddd;\n        }\n      }\n\n      tbody {\n        tr {\n          transition: background-color 0.2s ease;\n\n          &:hover {\n            background-color: #f9fafb;\n          }\n\n          td {\n            padding: 0.9rem 1rem;\n            // border-bottom: 1px solid var(--medium-gray);\n            // border: 1px solid #ddd;\n          }\n\n          td:last-child {\n            white-space: nowrap;\n\n            button {\n              margin-right: 0.5rem;\n              padding: 0.3rem 0.6rem;\n              font-size: 0.85rem;\n              border: none;\n              border-radius: 4px;\n              cursor: pointer;\n              background-color: #17a2b8;\n              color: white;\n\n              &:last-child {\n                background-color: #dc2626; // red for delete\n              }\n\n              &:hover {\n                opacity: 0.9;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .client-card-main {\n      background-color: var(--card-bg);\n      border: 1px solid var(--border-color);\n      border-radius: 0.75rem;\n      padding: 1rem;\n      position: relative;\n\n      .client-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 1.5rem;\n        padding-bottom: 0.5rem;\n        border-bottom: 1px dashed var(--medium-gray);\n\n        .client-name {\n          font-size: 1.2rem;\n          font-weight: 700;\n          color: #1f2937;\n          margin: 0;\n        }\n\n        .client-actions {\n          position: relative;\n\n          .client-action-button {\n            background-color: var(--primary-color);\n            border: 1px solid var(--border-color);\n            border-radius: 0.5rem;\n            padding: 8px 18px;\n            font-size: 0.95rem;\n            color: var(--text-color);\n            font-weight: 500;\n            display: flex;\n            align-items: center;\n            gap: 0.4rem;\n            cursor: pointer;\n            transition: background-color 0.2s ease, box-shadow 0.2s ease;\n\n            &:hover {\n              // background-color: var(--medium-gray);\n              box-shadow: 0 1px 4px var(--shadow-medium);\n            }\n\n            svg {\n              font-size: 1.1rem; // Slightly larger icon\n            }\n          }\n\n          .dropdown-menu {\n            position: absolute;\n            top: 3rem; // Adjust dropdown position\n            right: 0;\n            background-color: var(--card-bg);\n            border: 1px solid var(--border-color);\n            border-radius: 0.5rem;\n            box-shadow: 0 6px 16px var(--shadow-medium); // Stronger shadow for dropdown\n            min-width: 180px;\n            padding: 0.5rem 0;\n            z-index: 100;\n            list-style: none; // Remove bullet points\n\n            li {\n              padding: 0.75rem 1.2rem; // More padding\n              font-size: 0.9rem; // Clearer font size\n              color: var(--text-color);\n              cursor: pointer;\n              transition: background-color 0.2s ease;\n              display: flex;\n              align-items: center;\n\n              &:hover {\n                background-color: var(--light-gray);\n              }\n\n              &:not(:last-child) {\n                border-bottom: 1px solid var(--medium-gray); // Lighter separator\n              }\n\n              &.view {\n                color: #2563eb;\n              }\n\n              // Blue\n              &.update {\n                color: #10b981;\n              }\n\n              // Green\n              &.delete {\n                color: #ef4444;\n              }\n\n              // Red\n              &.message {\n                color: #8b5cf6;\n              }\n\n              // Violet\n            }\n          }\n        }\n      }\n\n      .client-details-grid {\n        display: grid;\n        grid-template-columns: repeat(\n          auto-fit,\n          minmax(280px, 1fr)\n        ); // Responsive grid\n        gap: 1rem;\n        margin-bottom: 1.5rem;\n        padding-bottom: 1rem;\n        border-bottom: 1px dashed var(--medium-gray);\n\n        .detail-item {\n          display: flex;\n          align-items: center;\n          gap: 0.5rem;\n          font-size: 0.95rem;\n          color: var(--text-color);\n\n          strong {\n            color: #1f2937; // Darker for labels\n          }\n\n          .client-detail {\n            color: #6b7280;\n          }\n\n          .detail-icon {\n            color: var(--primary-color);\n            font-size: 1.2rem;\n          }\n        }\n      }\n\n      .section-title {\n        font-size: 1.1rem;\n        font-weight: 600;\n        color: #1f2937;\n        margin-bottom: 0.8rem;\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n\n        .section-icon {\n          color: var(--primary-color);\n          font-size: 1.3rem;\n        }\n      }\n\n      .client-address {\n        p {\n          line-height: 1.6;\n          margin: 0;\n          color: var(--text-color);\n          font-size: 0.95rem;\n\n          .client-detail {\n            color: #6b7280;\n          }\n        }\n      }\n\n      .client-cases {\n        .case-counts {\n          display: flex;\n          gap: 1.5rem;\n          margin-bottom: 1rem;\n          font-size: 0.95rem;\n          color: var(--text-color);\n\n          span {\n            .client-detail {\n              color: var(--primary-color);\n              font-weight: 600;\n            }\n          }\n        }\n\n        .case-list {\n          margin-top: 0.5rem;\n\n          strong {\n            display: block;\n            margin-bottom: 0.3rem;\n            color: #1f2937;\n          }\n\n          ul {\n            list-style-type: disc; // Use regular disc bullets\n            padding-left: 1.2rem;\n            margin: 0;\n\n            li {\n              color: var(--text-color);\n              font-size: 0.9rem;\n              line-height: 1.4;\n            }\n          }\n        }\n      }\n    }\n\n    .no-clients-message {\n      // text-align: center;\n      // font-size: 1.1rem;\n      // color: #6b7280;\n      // padding: 2rem;\n      // background-color: var(--card-bg);\n      // border: 1px dashed var(--border-color);\n      // border-radius: 0.75rem;\n      // margin-top: 2rem;\n      // width: 100%;\n      text-align: center;\n      font-size: 1.1rem;\n      color: var(--text-color-medium);\n      padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);\n      background: var(--card-bg);\n      border-radius: 0.75rem;\n      border: 1px dashed var(--border-color);\n      box-shadow: 0 2px 5px var(--shadow-light);\n      margin-top: calc(var(--spacing-unit) * 2);\n      grid-column: 1 / -1;\n    }\n  }\n\n  .pagination-settings {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    font-size: 15px;\n    font-weight: 500;\n    padding: 4px 10px;\n    background-color: #e2e8f0;\n    border-radius: 6px;\n\n    label {\n      white-space: nowrap;\n      color: #1f2937;\n      font-size: 0.85rem;\n      font-weight: 400;\n    }\n\n    #clientPerPageSelect {\n      border: none;\n      border-radius: 6px;\n      outline: none;\n      padding: 3px 25px 3px 3px;\n      background-color: white;\n      font-size: 0.85rem;\n      color: #333;\n      cursor: pointer;\n      // min-width: 70px;\n\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n\n      background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23666'%3e%3cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3e%3c/svg%3e\");\n      background-repeat: no-repeat;\n      background-position: right 10px center;\n      background-size: 16px;\n\n      transition: all 0.2s ease;\n      box-shadow: none !important;\n\n      &:hover {\n        background-color: #fafafa;\n      }\n\n      &:focus {\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\n        background-color: white;\n      }\n\n      option {\n        border: none !important;\n        outline: none;\n        padding: 4px 8px;\n      }\n    }\n  }\n}\n\n/* Media Queries for Responsiveness */\n@media (max-width: 768px) {\n  .clients-container {\n    padding: 1rem;\n\n    .client-card-main {\n      padding: 1.5rem;\n\n      .client-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 0.8rem;\n\n        .client-name {\n          font-size: 1.5rem;\n        }\n\n        .client-actions {\n          align-self: flex-end;\n          width: 100%; // Make actions button take full width on smaller screens\n\n          .client-action-button {\n            width: 100%;\n            justify-content: center;\n          }\n\n          .dropdown-menu {\n            width: 100%;\n            left: 0;\n            right: auto;\n            transform: translateX(0); // Reset transform if any\n            text-align: center; // Center dropdown items\n          }\n        }\n      }\n\n      .client-details-grid {\n        grid-template-columns: 1fr; // Stack items on smaller screens\n      }\n\n      .client-address,\n      .client-cases {\n        p,\n        ul {\n          font-size: 0.9rem;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .clients-container {\n    padding: 0.5rem;\n\n    .client-card-main {\n      padding: 1rem;\n\n      .client-name {\n        font-size: 1.3rem;\n      }\n\n      .section-title {\n        font-size: 1rem;\n      }\n\n      .detail-item,\n      .client-address p,\n      .client-cases .case-counts span,\n      .client-cases .case-list ul li {\n        font-size: 0.85rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
